export default () => {
    const wrapper = document.querySelector('.eu-cookie-compliance-banner');
    const cookie = wrapper?.querySelector('.eu-cookie-compliance-message p:nth-of-type(2)');

    if (!cookie) return;

    const wordLimit = 25;
    const originalText = cookie.innerText;
    const words = originalText.split(" ");
    const button = document.createElement("button")
    button.classList.add("see-more");
    button.innerText = wrapper.getAttribute('data-see-more') || "See more";


    if (words.length > wordLimit) {
        cookie.innerText = words.slice(0, wordLimit).join(" ") + "...";
        cookie.classList.add("truncated");

        cookie.appendChild(button);
    }

    button.addEventListener("click", () => {
        if (cookie.classList.contains("truncated")) {
            cookie.innerText = originalText;
            cookie.classList.remove("truncated");
        }
    });
}
